module.exports = __webpack_public_path__ + "static/media/21.18d361a3.jpg";